import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class LoadingFileService {

  private loading = new BehaviorSubject(false);
  currentLoading = this.loading.asObservable();

  constructor() {
  }

  changeLoading(load: boolean) {
    this.loading.next(load);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loading-file.service.ts